import Icon from "components/atoms/Icon/Icon";
import Menu from "components/atoms/Menu/Menu";
import ProgressBar from "components/atoms/ProgressBar/ProgressBar";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { EUserRoles } from "types/user/user.type";
import { getClientStats } from "../../../store/slices/client.slice";
import Skeleton from "components/atoms/layout/Skeleton/Skeleton";
const Profile: React.FC<any> = ({
  name,
  credits,
  logout,
  unlimitedCredits,
  dropDown = true,
  isLoadingCredits,
}) => {
  const hasFetchedStats = useRef(false);
  const navigate = useNavigate();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const open = Boolean(anchor);
  const { data: client } = useAppSelector((state) => state.client);
  const { data: stats } = useAppSelector((state) => state.client.stats);
  const { data: user } = useAppSelector((state) => state.user);
  const isAdmin = user?.userRole === EUserRoles.ADMIN;
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!open || hasFetchedStats.current) return;
    dispatch(getClientStats());
    hasFetchedStats.current = true;
  }, [open]);
  return (
    <>
      <div
        className="flex items-center gap-3 cursor-pointer"
        onClick={(e) => setAnchor(e.currentTarget)}
      >
        <div className="flex flex-col truncate">
          <div className="truncate text-white-500">
            {name?.name} {name?.lastName}
          </div>
          <div className="flex items-center gap-2 mt-1 text-sm text-white-500">
            <Icon name="credits" size={18} className="!text-white-500" />
            {unlimitedCredits
              ? "Unlimited credits"
              : credits === 1
              ? `${credits} `
              : `${credits || 0} `}
          </div>
        </div>
        {dropDown && (
          <Icon
            name={open ? "chevron-up" : "chevron-down"}
            size={12}
            className="text-white-500 hidden md:block"
          />
        )}
      </div>
      {dropDown && (
        <Menu
          items={[
            {
              title: "Account",
              description: "Manage your account details",
              icon: "user",
              onClick: () => navigate("/user/myAccount"),
            },
            // ...(isAdmin ? [
            //   { title: 'Integrations', description: 'Connect third-party services', icon: 'layers', onClick: () => navigate("/integrations") }
            // ] : []),
            // { title: 'Tracking Pixel', description: 'Manage your pixel configuration', icon: 'code', onClick: () => navigate("/pixel") },
            // { title: 'Company Team', description: 'Manage your company team', icon: 'people', onClick: () => navigate("/company") },
            {
              title: "Logout",
              description: "Sign out of your account",
              icon: "logout",
              onClick: () => logout(),
            },
          ]}
          isOpen={open}
          anchor={anchor}
          setAnchor={setAnchor}
          position={"right"}
        >
          {isAdmin && client && stats.planName && (
            <div className="pt-2 pb-3 px-3 flex flex-col gap-3">
              <div className="flex flex-col gap-2">
                <h1 className="text-white-500 text-base font-bold">
                  {client.name}
                </h1>
                {(stats.planName || stats.planState) && (
                  <div className="flex gap-2">
                    {stats.planName && (
                      <div className="badge pm xs">{stats.planName}</div>
                    )}
                    {stats.planState && (
                      <div className="badge sd xs capitalize">
                        {stats.planState}
                      </div>
                    )}
                  </div>
                )}
              </div>
              <ProgressBar
                used={stats.rateLimitUsed}
                available={stats.rateLimitAvailable}
                label="Traffic"
                iconName="score"
              />
              <ProgressBar
                used={stats.creditsRevealUsed}
                available={stats.creditsRevealAvailable}
                label="Reveal Credits"
                iconName="credits"
              />
            </div>
          )}
        </Menu>
      )}
    </>
  );
};

export default Profile;
